import type { BridgeChartData } from "../types/data";
import type { BridgeChartViewport } from "../types/public";

/** Actual selectable edges, not a preset label or a claim about market freshness. O(1). */
export function viewportReadout(data: BridgeChartData, view: BridgeChartViewport) {
  const first = Math.ceil(view.start), last = Math.floor(view.end);
  if (!Number.isFinite(first) || !Number.isFinite(last) || first < 0 || last >= data.bars.length || first > last
      || data.symbol !== data.metadata.symbol || data.timeframe !== data.metadata.timeframe) return null;
  return { first: data.bars[first].date, last: data.bars[last].date,
    timeframe: data.timeframe, visible: last - first + 1, retained: data.bars.length };
}
